import { CouponRepository } from "@/domain/repositories";
import { CouponDataSource } from "../datasources/coupons";
import { CouponMapper } from "@/domain/mappers";
import { CouponResponse } from "../dtos/responses";
import { CreateCouponRequest } from "../dtos/requests";
import { CreateCouponInput, UpdateCouponInput } from "@/domain/dtos/inputs";
import { Coupon, ValidateCouponResult } from "@/domain/entities";

export class CouponRepoImpl implements CouponRepository {
  constructor(
    private readonly dataSource: CouponDataSource,
    private readonly mapper: CouponMapper<CouponResponse, CreateCouponRequest>,
  ) {}

  async createCoupon(params: CreateCouponInput): Promise<{ message: string }> {
    const data = this.mapper.toRequest(params);
    const { message } = await this.dataSource.createCoupon(data);

    return { message };
  }
  async getCoupons(query?: { page: number }): Promise<Coupon[]> {
    const data = await this.dataSource.getCoupons(query);

    return data.map((elem) => this.mapper.toDomain(elem));
  }

  async getCouponById(id: number): Promise<Coupon> {
    const data = await this.dataSource.getCouponById(id);

    return this.mapper.toDomain(data);
  }
  async updateCoupon(
    id: number,
    params: UpdateCouponInput,
  ): Promise<{ message: string }> {
    return this.dataSource.updateCoupon(id, params);
  }
  async deleteCoupon(id: number): Promise<{ message: string }> {
    return this.dataSource.deleteCoupon(id);
  }

  async validateCoupon(
    code: string,
    psychologistId: number,
    recurrency?: boolean,
    first_appointment?: boolean,
  ): Promise<ValidateCouponResult> {
    return this.dataSource.validateCoupon(code, psychologistId, recurrency, first_appointment);
  }
}
